import { render, staticRenderFns } from "./ConfigAusentes.vue?vue&type=template&id=54e29ed2&scoped=true&lang=pug&"
import script from "./ConfigAusentes.vue?vue&type=script&lang=js&"
export * from "./ConfigAusentes.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAusentes.vue?vue&type=style&index=0&id=54e29ed2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e29ed2",
  null
  
)

export default component.exports